import api from '@/lib/api/axios'
import type { ListParams, PaginatedResponse } from '@/lib/api/types'

export interface RequestApproval {
    objectID: string | null
    requestID: string | null
    requestdatetime: string | null
    userName: string | null
    objectDescription: string | null
    noObjects: number | null
    iconFilename: string | null
}

export const requestApprovalsApi = {
    list: (params?: ListParams) => {
        // Convert perPage to limit for backend compatibility
        const queryParams = params ? {
            ...params,
            limit: params.perPage || params.limit || 20,
            perPage: undefined,
        } : undefined
        // Remove undefined values
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key as keyof typeof queryParams] === undefined) {
                    delete queryParams[key as keyof typeof queryParams]
                }
            })
        }
        return api.get<PaginatedResponse<RequestApproval>>('/api/request-approvals', { params: queryParams })
    },
    approve: (requestID: string) => {
        return api.post<{ success: boolean }>('/api/request-approvals/approve', { requestID })
    },
    delete: (requestID: string) => {
        return api.post<{ success: boolean }>('/api/request-approvals/delete', { requestID })
    },
}
